import { apiClient } from './client';

export const treatmentApi = {
  getAll: (params) => apiClient.get('/treatments', { params }),
  getById: (id) => apiClient.get(`/treatments/${id}`),
  getByChild: (childId) => apiClient.get(`/treatments/child/${childId}`),
  getByEvent: (eventId) => apiClient.get(`/treatments/event/${eventId}`),
  getByEventAndChild: (eventId, childId) => apiClient.get(`/treatments/event/${eventId}/child/${childId}`),
  create: (data) => apiClient.post('/treatments', data, { headers: { 'Content-Type': 'multipart/form-data' } }),
  update: (id, data) => apiClient.put(`/treatments/${id}`, data, { headers: { 'Content-Type': 'multipart/form-data' } }),
  delete: (id) => apiClient.delete(`/treatments/${id}`),
};
